import * as React from 'react';

interface Props {
  width?: string;
  height?: string;
  color?: string;
}

const UploadIcon = ({ width, height, color }: Props) => {
  return (
    <svg viewBox="0 0 24 24" width={width || 24} height={height || 24}>
      <path
        fill={color || 'none'}
        d="M9,10V16H15V10H19L12,3L5,10H9M12,5.8L14.2,8H13V14H11V8H9.8L12,5.8M19,18H5V20H19V18Z"
      />
    </svg>
  );
};

export default UploadIcon;
